

export const EmptyDataHook = (defaultData) => {
  if (!defaultData || typeof defaultData !== "object") return {};
  return Object.keys(defaultData).reduce((acc, key) => {
    acc[key] = "";
    return acc;
  }, {});
};